export const longDateFormat = 'MMM D, YYYY';
export const shortYearDateFormat = "MMM D, 'YY";
export const timeFormat = 'hh:mmA';
export const timeFormatWithSeconds = 'hh:mm:ss a';
export const longDateFormatWithTime = `${longDateFormat} ${timeFormat}`;
export const longDateFormatWithTimeWithSeconds = `${longDateFormat} ${timeFormatWithSeconds}`;
